import { KeySections, KeySubjects } from './keys-subjects-section';

export const keyIdDatiEventoRiconoscimento = [
  KeySections.keyDatiGeneraliRiconoscimento,
  KeySections.keyDatiGeneraliConsAssRico,
  KeySections.keyDatiGeneraliRicoGen,
  KeySections.keyDatiGeneraliAssRico,
  KeySections.keyDatiGeneraliPresDoc,
  KeySections.keyDatiGeneraliConsRico,
  KeySections.keyDatiGeneraliConsenso,
  KeySections.keyDatiGeneraliConsAssCognridRico,
  KeySections.keyDatiGeneraliAssRicoP,
  KeySections.keyAutorizzazioneRiconoscimentoPadre,
  KeySections.keyDatiSpecificiMatr,
  KeySections.keyAssensoFiglio,
  KeySubjects.keyFiglio,
];

export const keyIdConsenso = [
  KeySections.keyTipoMancatoConsMadre,
  KeySections.keyAttoDiConsensoAtcoP,
  KeySections.keyDatiGeneraliConsRicoSent,
  KeySections.keyDatiGeneraliConsAssRico,
  KeySections.keyDatiSpecificiMatr,
];

export const keyRiconoscimentoList = [
  KeySections.keyAttoConsensoAtcom,
  KeySections.keyDatiGeneraliRiconoscimento,
  KeySections.keyAttoConsensoAtcop,
  KeySections.keyAttoRiconoscimentoMadre,
  KeySections.keyAutorizzazioneRiconoscimentoPadre,
  KeySections.keyAttoRiconoscimentoPadre,
  KeySections.keyAttoRiconoscimento,
  KeySections.keyEstremiSentenzaPadre,
  KeySections.keyEstremiSentenzaMadre,
];
